export default {
  dana: 60000,
  grosir: 1000,
  deposit: 30000,
};
